export const MESSAGE_CENTER_CONTAINER_TAG_NAME = 'message-center-container';
